import "./view.scss";
import { gsap } from "gsap";

window.addEventListener("DOMContentLoaded", () => {
  const tickerTracks = document.querySelectorAll(
    ".wp-block-blueprint-image-ticker .image-ticker-track"
  );

  tickerTracks.forEach((tickerTrack) => {
    const speedSetting = parseFloat(tickerTrack.getAttribute("data-speed")) || 30;
    const content = tickerTrack.querySelector(".image-ticker-content");
    if (!content) return;

    // Get actual pixel width of content
    const contentWidth = content.offsetWidth;
    
    // Calculate duration: speedSetting controls pixels per second
    const duration = contentWidth / speedSetting;

    // Use GSAP for pixel-perfect infinite loop
    gsap.to(tickerTrack, {
      x: -contentWidth,
      duration: duration,
      ease: "none",
      repeat: -1,
      modifiers: {
        x: gsap.utils.unitize(x => parseFloat(x) % contentWidth)
      }
    });
  });
});
